import React from 'react';
import { Section } from './Shared';
export const Bonuses = () => {
  return <Section className="bg-gray-50" data-id="element-13">
      <div className="max-w-5xl mx-auto" data-id="element-14">
        <h2 className="font-montserrat font-black text-3xl md:text-5xl uppercase leading-tight text-center mb-12" data-id="element-15">
          🎁 Bonos <span className="text-coral" data-id="element-16">GRATIS</span> por el día de hoy
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-8 max-w-4xl mx-auto" data-id="element-17">
          {[{
          title: 'Planner de Creadora: Tu Sistema Simple para Ser Constante',
          image: 'https://cdn.magicpatterns.com/uploads/eLX6bS2bbuBLcXqCQAitkN/planner_de_creadora_Ebook.png',
          description: 'Un planner descargable para organizar tu contenido semana a semana sin complicarte.'
        }, {
          title: '100 Ideas de Contenido (que SÍ funcionan)',
          image: 'https://cdn.magicpatterns.com/uploads/sANQ8B976TBqQKeve7FP5o/100_ideas_ebook.png',
          description: '100 ideas listas para usar en Instagram y TikTok. Nunca más te vas a quedar sin saber qué publicar.'
        }].map((bonus, idx) => <div key={idx} className="bg-white rounded-2xl shadow-md border border-gray-100 p-8 flex flex-col items-center text-center relative group" data-id="element-18">
              <div className="absolute top-4 right-4 bg-gold text-black font-bold text-xs px-3 py-1 rounded-full uppercase tracking-wider z-10" data-id="element-19">
                Gratis Hoy
              </div>

              <img src={bonus.image} alt={bonus.title} className="w-48 h-auto mb-6 drop-shadow-2xl group-hover:scale-105 transition-transform duration-300" data-id="element-20" />

              <h3 className="font-montserrat font-black text-xl uppercase leading-tight mb-4 text-black" data-id="element-21">
                {bonus.title}
              </h3>

              <p className="font-opensans text-gray-600 text-base" data-id="element-22">
                {bonus.description}
              </p>
            </div>)}
        </div>

        <p className="text-center text-gray-500 italic font-opensans text-sm" data-id="element-23">
          Incluidos sin costo adicional con tu compra
        </p>
      </div>
    </Section>;
};